import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApiCacheRootState } from './api-cache.reducer';

export const selectApiCacheState = createFeatureSelector<ApiCacheRootState>('apiCache');

export const selectApiCache = createSelector(
  selectApiCacheState,
  (state) => state?.cache || {}
);

export const selectApiCacheEntry = (key: string) =>
  createSelector(selectApiCache, (cache) => cache?.[key]);